<template>
  <b-card v-bind:title="title">
    <b-row>
      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'nsn-' + key" label="NSN:" v-bind:label-for="'input-nsn-' + key" label-class="quote-summary-label">
          <b-form-input
             size="sm"
             class="quote-summary-value" 
            v-bind:id="'input-nsn-' + key"
            v-model="response.nsn"
            v-bind:plaintext="true"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'part_number-' + key" label="P/N:" v-bind:label-for="'input-part_number-' + key" label-class="quote-summary-label">
          <b-form-input
             size="sm"
             class="quote-summary-value" 
            v-bind:id="'input-part_number-' + key"
            v-model="response.part_number"
            v-bind:plaintext="true"
              disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'description-' + key" label="Description:" v-bind:label-for="'input-description-' + key" label-class="quote-summary-label">
          <b-form-input
             size="sm"
             class="quote-summary-value" 
            v-bind:id="'input-description-' + key"
            v-model="response.description"
            v-bind:plaintext="true"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'coo-' + key" label="Weight / UOM:" v-bind:label-for="'input-weight_per_uom-' + key" label-class="quote-summary-label">
          <b-form-input
             size="sm"
             class="quote-summary-value" 
            v-bind:id="'input-weight_per_uom-' + key"
            v-model="response.weight_per_uom"
            v-bind:plaintext="true"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'coo-' + key" label="COO:" v-bind:label-for="'input-coo-' + key" label-class="quote-summary-label">
          <b-form-input 
             size="sm"
             class="quote-summary-value"
            :inputId="'input-coo-' + key"
            v-model="response.coo"            
          v-bind:plaintext="true"
              disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="2" md="6" sm="12">
        <b-form-group v-bind:id="'moq-' + key" label="MOQ:" v-bind:label-for="'input-moq-' + key" label-class="quote-summary-label">
          <b-form-input
             class="quote-summary-value"
            v-bind:id="'input-moq-' + key"
            v-model="response.minimum_order_quantity"
            v-bind:plaintext="true"
              disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>


    <additional-cost-read
      v-bind:response="response"
      v-bind:id="key"
    />

    <b-row v-if="response.no_quote_classification" align-h="center">
      <b-col lg="4" md="4" sm="12">
        <b-form-group  v-bind:id="'no_quote_classification-' + key" label="No-Quote Reason:" v-bind:label-for="'input-no_quote_classification-' + key" label-class="quote-summary-label">
          <b-form-input
            class="quote-summary-value" 
            v-bind:id="'input-no_quote_classification-' + key"
            v-model="response.no_quote_classification"
            v-bind:plaintext="true"
            disabled
          ></b-form-input>
          <b-form-input
            v-if="response.no_quote_classification === 'Other'"
            class="quote-summary-value" 
            v-bind:id="'input-no_quote_other_reason-' + key"
            v-model="response.no_quote_other_reason"
            v-bind:plaintext="true"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-else-if="response.will_advise_dt != null " align-h="center">
      <b-col lg="4" md="4" sm="12">
        <b-form-group  v-bind:id="'will_advise_dt-' + key" label="Will-Advise Date:" v-bind:label-for="'input-will_advise_dt-' + key" label-class="quote-summary-label">
          <b-form-datepicker
            class="quote-summary-value" 
            v-bind:id="'input-will_advise_dt-' + key"
            v-model="response.will_advise_dt"
            v-bind:plaintext="true"
            disabled
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
    </b-row>



    <b-card v-else>
      <b-form-group v-for="(response_quantity, quantity_index) in response.quantities" :key="quantity_index" label-class="quote-summary-label">
        <quantity-read

          v-bind:response="response.quantities[quantity_index]"
          v-bind:line="response.id"
          v-bind:index="quantity_index"
        />
      </b-form-group>
    </b-card>

  </b-card>
</template>

<script>
import ReadQuantity from './ReadQuantity';
import ReadAdditionalCost from "./ReadAdditionalCost";

export default {
  name: "quote-line-read",
  props: [
    "response", 
    "title"
    ],
  data() {
    return {
      will_advise_dt_string: ""
    };
  },
  components: {
    'quantity-read': ReadQuantity,
    "additional-cost-read": ReadAdditionalCost
  },
  computed: {
    key: function() {
      return "quote_line_" + this.response.id;
    }
  },
    mounted() {    
    
  }
};
</script>
<style scoped>
 .form-control-plaintext.form-control-sm {
   padding-left: 9px !important;
 }
 .form-group {
    margin-bottom: 0.2rem;
}
</style>